import './App.css';
import Experience from './components/Experience';

function App() {
  return (
    <div className="App">
      <h1>El meu currículum</h1>
      <Experience />
    </div>
  );
}

export default App;
